var _regeneratorRuntime = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Dependencies
 */
var base64url = require('base64url');

var JWS = require('./JWS');

var DataError = require('../errors/DataError');

var JOSEHeader = require('./JOSEHeader');
/**
 * JWT
 */


var JWT = /*#__PURE__*/function () {
  "use strict";

  function JWT() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, JWT);

    this.type = data.type;
    this.segments = data.segments;
    this.header = new JOSEHeader(data.header);
    this.protected = data.protected;
    this.unprotected = data.unprotected;
    this.iv = data.iv;
    this.aad = data.aad;
    this.ciphertext = data.ciphertext;
    this.tag = data.tag;
    this.recipients = data.recipients;
    this.payload = data.payload;
    this.signatures = data.signatures;
    this.signature = data.signature;
    this.key = data.key;
    this.serialization = data.serialization || 'compact'; // default
  }
  /**
   * decode
   *
   * @description
   * Decode a JSON Web Token
   *
   * @param {string} data
   * @returns {JWT}
   */


  _createClass(JWT, [{
    key: "isJWE",

    /**
     * isJWE
     */
    value: function isJWE() {
      return !!this.header.enc;
    }
    /**
     * resolveKeys
     */

  }, {
    key: "resolveKeys",
    value: function resolveKeys(jwks) {
      var kid = this.header.kid;
      var keys, match; // treat an array as the "keys" property of a JWK Set

      if (Array.isArray(jwks)) {
        keys = jwks;
      } // presence of keys indicates object is a JWK Set


      if (jwks.keys) {
        keys = jwks.keys;
      } // wrap a plain object they is not a JWK Set in Array


      if (!jwks.keys && typeof jwks === 'object') {
        keys = [jwks];
      } // ensure there are keys to search


      if (!keys) {
        throw new DataError('Invalid JWK argument');
      } // match by "kid" or "use" header


      if (kid) {
        match = keys.find(function (jwk) {
          return jwk.kid === kid;
        });
      } else {
        match = keys.find(function (jwk) {
          return jwk.use === 'sig';
        });
      } // assign matching key to JWT and return a boolean


      if (match) {
        this.key = match.cryptoKey;
        return true;
      } else {
        return false;
      }
    }
    /**
     * encode
     *
     * @description
     * Encode a JWT instance
     *
     * @returns {Promise}
     */

  }, {
    key: "encode",
    value: function () {
      var _encode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = this;

                if (!this.isJWE()) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", JWE.encrypt(token));

              case 5:
                return _context.abrupt("return", JWS.sign(token));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function encode() {
        return _encode.apply(this, arguments);
      }

      return encode;
    }()
    /**
     * verify
     *
     * @description
     * Verify a decoded JWT instance
     *
     * @returns {Promise}
     */

  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", JWS.verify(this));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verify() {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }], [{
    key: "decode",
    value: function decode(data) {
      var ExtendedJWT = this;
      var jwt;

      if (typeof data !== 'string') {
        throw new DataError('JWT must be a string');
      } // JSON of Flattened JSON Serialization


      if (data.startsWith('{')) {
        try {
          data = JSON.parse(data, function () {});
        } catch (error) {
          throw new DataError('Invalid JWT serialization');
        }

        if (data.signatures || data.recipients) {
          data.serialization = 'json';
        } else {
          data.serialization = 'flattened';
        }

        jwt = new ExtendedJWT(data, {
          filter: false
        }); // Compact Serialization
      } else {
        try {
          var serialization = 'compact';
          var segments = data.split('.');
          var length = segments.length;

          if (length !== 3 && length !== 5) {
            throw new Error('Malformed JWT');
          }

          var header = JSON.parse(base64url.decode(segments[0])); // JSON Web Signature

          if (length === 3) {
            var type = 'JWS';
            var payload = JSON.parse(base64url.decode(segments[1]));
            var signature = segments[2];
            jwt = new ExtendedJWT({
              type: type,
              segments: segments,
              header: header,
              payload: payload,
              signature: signature,
              serialization: serialization
            }, {
              filter: false
            });
          } // JSON Web Encryption


          if (length === 5) {//let type = 'JWE'
            //let [protected, encryption_key, iv, ciphertext, tag] = segments
            //jwt = new ExtendedJWT({
            //  type,
            //  protected: base64url.decode(JSON.parse(protected)),
            //  encryption_key,
            //  iv,
            //  ciphertext,
            //  tag,
            //  serialization
            //})
          }
        } catch (error) {
          throw new DataError('Invalid JWT compact serialization');
        }
      }

      return jwt;
    }
    /**
     * encode
     *
     * @description
     * Encode a JSON Web Token
     *
     * @param {Object} header
     * @param {Object} payload
     * @param {CryptoKey} key
     *
     * @returns {Promise}
     */

  }, {
    key: "encode",
    value: function encode(header, payload, key) {
      var jwt = new JWT(header, payload);
      return jwt.encode(key);
    }
    /**
     * verify
     *
     * @description
     *
     * @param {CryptoKey} key
     * @param {string} token
     *
     * @returns {Promise}
     */

  }, {
    key: "verify",
    value: function () {
      var _verify2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, token) {
        var jwt;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                jwt = JWT.decode(token);
                jwt.key = key;
                return _context3.abrupt("return", jwt.verify().then(function (verified) {
                  return jwt;
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function verify(_x, _x2) {
        return _verify2.apply(this, arguments);
      }

      return verify;
    }()
  }]);

  return JWT;
}();
/**
 * Export
 */


module.exports = JWT;